module.exports = __webpack_public_path__ + "e4fa25a17a40d3e286f4ef1f852646fa.pdf";